// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"595":"01b8621a","695":"7b1185ed","739":"088f4bde","891":"8602f7a9"}[chunkId] + ".css";
};